import React, { useEffect, useState } from 'react';
import CharacterStockIcon from 'react/chat/inner/display_pieces/messages/CharacterStockIcon';
import { refreshDiscordAvatar } from 'functions/discordAvatarRefresh';

// Fired on window when a player picks another chat picture on their profile
// card, so their messages already on screen switch without a reload.
export const CHAT_PICTURE_CHANGED = 'smashladder:chat-picture-changed';

export function announceChatPicture(playerId, chatPicture) {
	window.dispatchEvent(new CustomEvent(CHAT_PICTURE_CHANGED, { detail: { playerId, chatPicture } }));
}

// The avatar in the Standard chat style's gutter, on the first message of a
// run. The sender's Discord picture with their main on its corner, or the main's
// stock icon alone when they picked it (player.chat_picture) or have no Discord.
// A stored Discord URL breaks when they change avatars on Discord, so one that
// fails to load falls back to the stock icon and the server is asked for the
// current one.
export default function ChatAvatar({ player, character }) {
	const [failedAvatarUrls, setFailedAvatarUrls] = useState([]);
	const [refreshedAvatarUrl, setRefreshedAvatarUrl] = useState(null);
	const [pickedPicture, setPickedPicture] = useState(null);

	useEffect(() => {
		const onPictureChanged = (event) => {
			if(event.detail.playerId === player.id) {
				setPickedPicture(event.detail.chatPicture);
			}
		};
		window.addEventListener(CHAT_PICTURE_CHANGED, onPictureChanged);
		return () => window.removeEventListener(CHAT_PICTURE_CHANGED, onPictureChanged);
	}, [player.id]);

	const storedAvatarUrl = player.avatar_url;
	const avatarUrl = refreshedAvatarUrl && !failedAvatarUrls.includes(refreshedAvatarUrl) ? refreshedAvatarUrl : storedAvatarUrl;
	const chatPicture = pickedPicture || player.chat_picture;
	const showsDiscord = !!avatarUrl && chatPicture !== 'main' && !failedAvatarUrls.includes(avatarUrl);
	const onAvatarError = () => {
		setFailedAvatarUrls((failed) => [...failed, avatarUrl]);
		if(avatarUrl === storedAvatarUrl) {
			refreshDiscordAvatar(player.id).then(setRefreshedAvatarUrl);
		}
	};

	if(showsDiscord) {
		return (
			<span className='chat-avatar chat-avatar--discord' aria-hidden='true'>
				<img className='chat-avatar__picture' src={avatarUrl} alt='' loading='lazy' onError={onAvatarError} />
				{character && <CharacterStockIcon character={character} className='chat-avatar__badge' decorative={true} />}
			</span>
		);
	}
	if(character) {
		return (
			<span className='chat-avatar chat-avatar--stock' aria-hidden='true'>
				<CharacterStockIcon character={character} className='chat-avatar__stock' decorative={true} />
			</span>
		);
	}
	return <span className='chat-avatar chat-avatar--empty' aria-hidden='true' />;
}
